import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-03-29'
        tag='Mercari'
        title='Mercari eBay Import Tool: Your quick access from eBay to Mercari.'
      >
        <p>
          People new to the online business world would probably think that selling online is way easier than selling in
          a physical store. They think that because online sellers are running their businesses in the comforts of their
          home or manage it anywhere or on the go, online ventures are less time-consuming and require less effort. But
          once they are in and have first-hand experience managing this type of venture, the realization of the
          misconception gets real.{' '}
        </p>
        <p>
          While it is true that both share many similarities in how they generate revenue and success for business
          owners, the style, approach, and business strategies used differ as the target market of online sellers is
          also different.{' '}
        </p>
        <p>
          Physical stores can make their presence known in no time. With a physical presence in the real world, it is
          easy for shoppers to remember and recognize their business. Aside from being visible, they also provide access
          to their items which gives the potential buyer the chance to have a feel and physically test their products
          which significantly influences their purchase decision. Unfortunately, this is not the case for online shops.{' '}
        </p>
        <p>
          The online world is vast. So vast that anything posted online these days easily gets drowned as there are tons
          and tons of new posts every minute. In the case of online selling, listings are highly at risk of getting
          pushed down to the bottom due to the tough competition sellers have.
        </p>
        <p>
          Ensuring that a seller is always on top of the game requires more time and attention. So, sellers must know
          the tools and features of the marketplace they are selling in to help them maximize their time while doing
          more to keep up with each platform's algorithm.{' '}
        </p>
        <p>
          This is why tools that help sellers import their listings from one marketplace to another are advantageous.
          Not only does it enable a wider audience reach, but it also saves time and effort, which allows sellers to
          focus on other things that grow their business.
        </p>
        <p>
          One good example of these tools is the eBay Import Tool of Mercari. If you are a Mercari seller or an existing
          eBay seller who wants to venture to Mercari, read on and learn how this tool can help you!
        </p>

        <h3>About eBay Import Tool </h3>
        <p>
          For sure, you've heard all about eBay and how it is the second most famous reselling site following Amazon.
          Many sellers flock to this website; hence the number of sellers is also high. Of course, more shoppers mean
          good business.
        </p>
        <p>
          Mercari understands the demand of juggling multiple marketplaces at once, and crossposting to their platform
          can take time and effort when done manually. With their Import tool, sellers can now list items from their
          eBay account to Mercari.
        </p>
        <p>
          This tool is fairly new on the platform, and it is still in its BETA stage of development. Meaning access is
          quite limited but will be open to all users soon. Mercari sellers should note that this feature is only
          available to those who are part of the Mercari Pro Seller BETA program and can only be accessed through the
          website version on a computer.{' '}
        </p>

        <h3>Information You Can Import</h3>
        <p>When using the eBay Import tool, the following details are copied to Mercari:</p>
        <ul>
          <li>Listing Title that is limited to 40 characters</li>
          <li>Item photos that are limited to the first 12 images</li>
          <li>Listing description with 1000 characters</li>
          <li>The listing price that is inclusive of the item's final price and shipping fee</li>
          <li>Category</li>
          <li>Brand</li>
          <li>Zipcode</li>
          <li>Item's condition </li>
        </ul>

        <h3>Listing Information Not Included in the Import</h3>
        <p>
          Take note of this information that won't come along your listing when using the eBay Import Tool. Some of
          which will require you manually add them in your Mercari listing:
        </p>
        <ul>
          <li>Your listing's metadata</li>
          <li>The delivery settings. All of the imported listings will be set as "Ship on your own" by default</li>
          <li>Return policies</li>
          <li>Listing policies</li>
          <li>Item inventory</li>
          <li>Quantity limit per buyer</li>
          <li>Sales Tax</li>
        </ul>

        <h3>Pro Seller Program</h3>
        <p>
          This exclusive program of Mercari for its top sellers comes with many perks and privileges. Here are some of
          the perks that sellers can get by joining this program:
        </p>
        <ol>
          <li>
            <strong>Pro Seller badge:</strong> This symbol will be visible to all shoppers, which will help you stand
            out.
          </li>
          <li>
            <strong>Bulk Import Tool access:</strong> This will let you import and have your eBay listing in sync so you
            can efficiently work while selling faster.
          </li>
          <li>
            <strong>Inventory management:</strong> This feature will help you do bulk deactivation of listings and
            perform an advance search.
          </li>
          <li>
            <strong>Free Ad Network promotion:</strong> This amazing feature helps you reach a broader audience through
            Google Shopping without spending a dime.{' '}
          </li>
          <li>
            <strong>Enhanced Analytics and VIP service:</strong> These features are coming soon, but once they're out,
            they will help you get insights into growing your business plus, you will also have a dedicated account
            manager with 24 hours support.
          </li>
        </ol>
        <p>
          <strong>Note:</strong> Mercari's Pro Seller Program application has a waiting list at the moment. If you are
          interested in joining the program and willing to be waitlisted, you can sign up{' '}
          <a href='https://docs.google.com/forms/d/e/1FAIpQLSdeXCyFLy1CzYLKiLREdW4TpRofHnORbmaa6X0W_K1t2_mULg/viewform'>
            here
          </a>
          .
        </p>

        <h3>Rules to follow when using the eBay Import Tool</h3>
        <p>
          Sellers should ensure that they only import particular listings that comply with Mercari's criteria to get
          started. All of them are as follows:
        </p>
        <ul>
          <li>Ensure that the items you want to import are from eBay's US website only.</li>
          <li>The listings should not be older than 120 days.</li>
          <li>The listing price should be between $5 - $2,000, inclusive of the shipping fee.</li>
          <li>All listings should be priced using USD currency.</li>
          <li>The listings you are importing are not Auction items.</li>
          <li>Listings should not have stock photos.</li>
          <li>Ensure that you only import listings with a "flat" shipping fee.</li>
          <li>Items that exceed Mercari's supported shipping size are not allowed to be imported.</li>
          <li>Any item that violates Mercari's Terms and Policies cannot be imported (i.e., prohibited items)</li>
        </ul>
        <p>
          When the import is done, sellers are notified via the email that is registered under your Mercari account.
        </p>

        <h3>Cross-list with OneShop</h3>
        <p>
          Now that you are equipped with how the eBay Import tool works on Mercari, it's now time for you to explore how
          you can easily cross-list on other marketplaces aside from Mercari.{' '}
        </p>
        <p>
          You can also use cross-listing tools like OneShop to sell on Poshmark, Depop, and Tradesy. This convenient app
          can help you save lots of time to grow your business and tend to more important things in life, including
          having more time for your personal life. With just one draft, you can conveniently cross-list to multiple
          online selling accounts you have linked to OneShop.
        </p>
        <p>
          You can find out more by visiting <a href='http://tools.oneshop.com'>oneshop.com</a> or test the waters and
          see how OneShop can help you improve your selling journey with our{' '}
          <a href='https://tools.oneshop.com/signup'>7-day free trial</a> without any credit card required.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
